const CardInfo = ({ title, amount, highlighned, isLoading }) => {
  const isFilled = highlighned

  const sectionClass = isFilled
    ? 'bg-success text-white border-transparent'
    : 'bg-surface text-text border-border'

  const amountClass = isFilled ? 'text-white' : 'text-text'
  const titleClass = isFilled ? 'text-white/80' : 'text-muted'

  return (
    <section
      className={`mt-1 flex flex-col items-center justify-center gap-0.5 px-3 py-2 sm:py-3 shadow-card rounded-card border ${sectionClass} font-sans`}
    >
      <div className='flex items-center gap-x-2'>
        <p className={`text-[clamp(1.1rem,2vw,1.55rem)] font-semibold tabular-nums ${amountClass}`}>
          {isLoading ? '...' : amount}
        </p>
      </div>
      <p className={`text-[0.65rem] sm:text-[0.7rem] font-medium ${titleClass}`}>
        {title}
      </p>
    </section>
  )
}

export default CardInfo
